import { getMerchantLatestProducts } from 'services/api/merchants/latest-products/get-latest-products';

export const fetchMerchantLatestProducts = async () => {
  const latestProducts = await getMerchantLatestProducts(20);

  return latestProducts;
};
